import React from 'react';
import { Form } from 'formik';
import { Col, Row } from 'reactstrap';
import S3FileUploadField from 'components/S3FileUploadField';
import EditUploadDownloadWrapper from 'components/EditUploadDownloadWrapper';
import LoadingButton from 'components/common/LoadingButton';

const VendorForeignKycForm = (props) => {
  const { handleSubmit, isSubmitting, isValid, dirty, values, setFieldValue } =
    props;

  const downloadImage = async (imageUrl, imageName) => {
    if (!imageUrl) return '';

    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = imageName || 'document';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading image:', error);
      // Fallback for CORS or other fetch issues
      window.open(imageUrl, '_blank');
    }
  };

  const companyFormationDocumentImage = values?.companyFormationDocument
    ? values?.companyFormationDocument.split('/')
    : values?.companyFormationDocument;

  const foreignIdVerificationDocumentImage =
    values?.foreignIdVerificationDocument
      ? values?.foreignIdVerificationDocument.split('/')
      : values?.foreignIdVerificationDocument;

  const userVerificationDocument = values?.userVerificationDocument
    ? values?.userVerificationDocument.split('/')
    : values?.userVerificationDocument;

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col sm={5} xxl={5} className="mb-2">
          <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
            Company Formation Document
          </span>
          <span className="f-12 text-dark-525 fw-medium d-block">
            {values.companyFormationDocument ? (
              <EditUploadDownloadWrapper
                fileName={
                  companyFormationDocumentImage
                    ? companyFormationDocumentImage[
                    companyFormationDocumentImage.length - 1
                    ]
                    : companyFormationDocumentImage
                }
                handleDownload={() =>
                  downloadImage(
                    values?.companyFormationDocument,
                    companyFormationDocumentImage
                      ? companyFormationDocumentImage[
                      companyFormationDocumentImage.length - 1
                      ]
                      : companyFormationDocumentImage,
                  )
                }
                handleCancel={() => {
                  setFieldValue('companyFormationDocument', '');
                }}
                name="companyFormationDocument"
              />
            ) : (
              <div className="mt-3">
                <S3FileUploadField
                  label=""
                  name="companyFormationDocument"
                  pathUrl="images/traders/company_formation_document"
                  accept=".png, .jpg, .jpeg, .pdf"
                />
              </div>
            )}
          </span>
        </Col>
        <Col sm={5} xxl={5} className="mb-2">
          <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
            Foreign ID Verification Document
          </span>
          <span className="f-12 text-dark-525 fw-medium d-block">
            {values.foreignIdVerificationDocument ? (
              <EditUploadDownloadWrapper
                fileName={
                  foreignIdVerificationDocumentImage
                    ? foreignIdVerificationDocumentImage[
                    foreignIdVerificationDocumentImage.length - 1
                    ]
                    : foreignIdVerificationDocumentImage
                }
                handleDownload={() =>
                  downloadImage(
                    values?.foreignIdVerificationDocument,
                    foreignIdVerificationDocumentImage
                      ? foreignIdVerificationDocumentImage[
                      foreignIdVerificationDocumentImage.length - 1
                      ]
                      : foreignIdVerificationDocumentImage,
                  )
                }
                handleCancel={() => {
                  setFieldValue('foreignIdVerificationDocument', '');
                }}
                name="foreignIdVerificationDocument"
              />
            ) : (
              <div className="mt-3">
                <S3FileUploadField
                  label=""
                  name="foreignIdVerificationDocument"
                  pathUrl="images/traders/foreignIdVerificationDocument"
                  accept=".png, .jpg, .jpeg, .pdf"
                />
              </div>
            )}
          </span>
        </Col>
        <Col sm={5} xxl={5} className="mb-2">
          <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
            Visiting Card
          </span>
          <span className="f-12 text-dark-525 fw-medium d-block">
            {values.userVerificationDocument ? (
              <EditUploadDownloadWrapper
                fileName={
                  userVerificationDocument
                    ? userVerificationDocument[
                    userVerificationDocument.length - 1
                    ]
                    : userVerificationDocument
                }
                handleDownload={() =>
                  downloadImage(
                    values?.userVerificationDocument,
                    userVerificationDocument
                      ? userVerificationDocument[
                      userVerificationDocument.length - 1
                      ]
                      : userVerificationDocument,
                  )
                }
                handleCancel={() => {
                  setFieldValue('userVerificationDocument', '');
                }}
                name="userVerificationDocument"
              />
            ) : (
              <div className="mt-3">
                <S3FileUploadField
                  name="userVerificationDocument"
                  pathUrl="images/traders/user_verification_document"
                  accept=".png, .jpg, .jpeg, .pdf"
                />
              </div>
            )}
          </span>
        </Col>
        <Col sm={10} className="text-end">
          <LoadingButton
            loading={isSubmitting}
            disabled={
              !isValid ||
              !dirty ||
              isSubmitting ||
              (!values.companyFormationDocument?.length &&
                !values.foreignIdVerificationDocument?.length)
            }
            color="warning"
            size="sm"
            type="submit"
            className="mw-100 loading-button"
          >
            Update
          </LoadingButton>
        </Col>
      </Row>
    </Form>
  );
};

export default VendorForeignKycForm;
